export const getters = {
    list: state => state.list,
    columns: state => state.columns,
    model: state => state.model,
    inventory: state => state.inventory,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
};
